import { useMemo } from 'react';

export default function useLanguageCodes(languageCodesRead: any, languageCodesReadAdd: any) {
  return useMemo(() => {
    console.debug('useLanguageCodes/useMemo/languageCodesRead', languageCodesRead); //DELETE
    console.debug('useLanguageCodes/useMemo/languageCodesReadAdd', languageCodesReadAdd); //DELETE

    if (!languageCodesRead || !languageCodesReadAdd) return undefined;

    return [
      ...languageCodesRead,
      ...languageCodesReadAdd,
    ];
  }, [languageCodesRead, languageCodesReadAdd,]);
}